// extracted by css-extract-rspack-plugin
export default {"dismissalCommentTextarea":"BaseSharedDismissalForm-module__dismissalCommentTextarea__m6ubX"};